import initialState from "./initialState";

export function CarrierPropertiesReducer(
  state = initialState.CarrierPropertiesReducer,
  action
) {
  switch (action.type) {
    case "CARRIER_PROPERTIES_REQUEST": {
      const { propertyNames } = action.payload;

      return {
        ...state,
        ...propertyNames.reduce(
          (out, k) => ({
            ...out,
            [k]: {
              status: 0,
              value: null,
            },
          }),
          {}
        ),
      };
    }

    case "CARRIER_PROPERTIES_SUCCESS": {
      const { response, propertyNames } = action.payload;
      return {
        ...state,
        ...propertyNames.reduce(
          (out, k) => ({
            ...out,
            [k]: {
              status: 1,
              value: null,
            },
          }),
          {}
        ),
        ...response.reduce(
          (out, cp) => ({
            ...out,
            [cp.key]: {
              status: 1,
              value: cp.value,
            },
          }),
          {}
        ),
      };
    }

    case "CARRIER_PROPERTIES_RESET":
      return {};

    default:
      return state;
  }
}
